import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Hub/Dashboard';
import Admin from './pages/Admin';
import SpecialOrdersApp from './pages/SpecialOrders';
import SpikesGearApp from './pages/SpikesGear';
import FileSharingApp from './pages/FileSharing';
import UniformOrdersApp from './pages/UniformOrders';
import TeamStoreManagementApp from './pages/TeamStoreManagement';
import HubAssistant from './pages/HubAssistant';
import MyDesk from './pages/MyDesk';
import KerrscreenProduction from './pages/KerrscreenProduction';
import WorkOrdersApp from './pages/WorkOrders';
import SupportTicketsApp from './pages/SupportTickets';
import Vendors from './pages/Vendors';
import TeamStoreCheckInOut from './pages/TeamStoreCheckInOut';
import IntakeQueueApp from './pages/IntakeQueue';
import CareersApp from './pages/Careers';
import CrmApp from './pages/CRM';
import { SpiritWearDashboard } from './pages/SpiritWear';
// EmailMarketingApp archived - WIP
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/hub"
            element={
              <Layout>
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/admin"
            element={
              <Layout>
                <ProtectedRoute requiredRole="admin">
                  <Admin />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/special-orders/*"
            element={
              <Layout>
                <ProtectedRoute requiredPermission="special-orders:read">
                  <SpecialOrdersApp />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/spikes-gear/*"
            element={
              <Layout>
                <ProtectedRoute requiredPermission="spikes-gear:read">
                  <SpikesGearApp />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/file-sharing/*"
            element={
              <Layout>
                <ProtectedRoute requiredPermission={["file-sharing:read", "kerrscreen:read"]}>
                  <FileSharingApp />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/league-uniform-management/*"
            element={
              <Layout>
                <ProtectedRoute requiredPermission="uniform-orders:read">
                  <UniformOrdersApp />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/team-store-management/*"
            element={
              <Layout>
                <ProtectedRoute requiredPermission="team-stores:read" requiredRole="admin">
                  <TeamStoreManagementApp />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/hub-assistant"
            element={
              <Layout>
                <ProtectedRoute requiredRole="admin">
                  <HubAssistant />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/my-desk"
            element={
              <Layout>
                <ProtectedRoute requiredRole="admin">
                  <MyDesk />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/kerrscreen-production/*"
            element={
              <Layout>
                <ProtectedRoute requiredPermission="kerrscreen:read">
                  <KerrscreenProduction />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/work-orders/*"
            element={
              <Layout>
                <ProtectedRoute requiredPermission="work-orders:read" requiredRole="admin">
                  <WorkOrdersApp />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/support-tickets/*"
            element={
              <Layout>
                <ProtectedRoute requiredPermission="support-tickets:read" requiredRole="admin">
                  <SupportTicketsApp />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/vendors"
            element={
              <Layout>
                <ProtectedRoute requiredRole="admin">
                  <Vendors />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/team-store-checkin-checkout"
            element={
              <Layout>
                <ProtectedRoute>
                  <TeamStoreCheckInOut />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/intake-queue/*"
            element={
              <Layout>
                <ProtectedRoute requiredPermission="uniform-orders:read" requiredRole="admin">
                  <IntakeQueueApp />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/careers/*"
            element={
              <Layout>
                <ProtectedRoute requiredPermission="careers:read" requiredRole="admin">
                  <CareersApp />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/crm/*"
            element={
              <Layout>
                <ProtectedRoute requiredPermission="crm:read">
                  <CrmApp />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/spirit-wear/*"
            element={
              <Layout>
                <ProtectedRoute requiredRole="admin">
                  <SpiritWearDashboard />
                </ProtectedRoute>
              </Layout>
            }
          />
{/* EmailMarketingApp route archived - WIP */}
          <Route
            path="/unauthorized"
            element={
              <Layout>
                <div className="error-page">
                  <h1>Access Denied</h1>
                  <p>You don't have permission to access this resource.</p>
                  <a href="/hub">Back to HUB</a>
                </div>
              </Layout>
            }
          />
          <Route
            path="/"
            element={<Navigate to="/hub" replace />}
          />
          <Route
            path="*"
            element={
              <Layout>
                <div className="error-page">
                  <h1>Page Not Found</h1>
                  <p>The page you're looking for doesn't exist.</p>
                  <a href="/hub">Back to HUB</a>
                </div>
              </Layout>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
